import * as React from 'react';
import { IconProps, SIZE_MAP } from '../types';
import { cn } from '../../../utils/cn';

const AlertTriangleFilledIcon = ({ size = 'lg', className, ...props }: IconProps) => {
  const px = SIZE_MAP[size];

  return (
    <svg
      width={px}
      height={px}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('text-primary', className)}
      {...props}
    >
      <path
        d="M11.3386 2.99451C11.7594 2.80741 12.2401 2.80741 12.6609 2.99451C12.9792 3.13612 13.1909 3.38766 13.3455 3.60583C13.5021 3.82709 13.6713 4.12132 13.863 4.45251L21.0759 16.9095C21.2685 17.2422 21.4393 17.5367 21.5535 17.7836C21.666 18.0268 21.7791 18.3365 21.7429 18.684C21.695 19.1425 21.4546 19.5592 21.0818 19.8304C20.7992 20.0359 20.4746 20.0931 20.2078 20.1176C19.937 20.1424 19.5969 20.142 19.2126 20.142H4.78784C4.40341 20.142 4.06258 20.1424 3.79175 20.1176C3.52488 20.0931 3.20027 20.0359 2.91772 19.8304C2.5449 19.5592 2.30452 19.1425 2.25659 18.684C2.22039 18.3365 2.33353 18.0268 2.44604 17.7836C2.56024 17.5367 2.73099 17.2422 2.92358 16.9095L10.1365 4.45251C10.3282 4.12132 10.4974 3.82709 10.6541 3.60583C10.8086 3.38766 11.0203 3.13612 11.3386 2.99451Z"
        fill="currentColor"
      />
      <path
        d="M12.0085 15.5731L12.0857 15.577C12.4636 15.6157 12.7585 15.935 12.7585 16.3231C12.7583 16.7111 12.4635 17.0306 12.0857 17.0692L12.0085 17.0731H11.9998C11.5857 17.0731 11.25 16.7371 11.2498 16.3231C11.2498 15.9089 11.5855 15.5731 11.9998 15.5731H12.0085ZM11.2498 12.8153V9.3075C11.2498 8.89328 11.5855 8.5575 11.9998 8.5575C12.414 8.5575 12.7498 8.89328 12.7498 9.3075V12.8153C12.7496 13.2294 12.4139 13.5653 11.9998 13.5653C11.5856 13.5653 11.2499 13.2294 11.2498 12.8153Z"
        fill="white"
      />
    </svg>
  );
};



export default AlertTriangleFilledIcon;
